import { get, patch, post, destroy } from './httpClient'

export const getBranches = (query) => get('/branch', query)
export const addBranch = (body) => post('/branch/create', body)
export const updateBranch = (id, body) => patch('/branch/update/' + id, body)
export const deleteBranch = (ids) => destroy('/branch/delete', { branch_id: ids })
